import {
	GET_WISHLIST_ITEM_REQUEST,
	GET_WISHLIST_ITEM_SUCCESS,
	GET_WISHLIST_ITEM_ERROR,
	RESET_WISHLIST_ITEM_DATA
} from 'actions/MyAccountActions/wishListPageActions';
import { REMOVE_WISHLIST_ITEM_SUCCESS } from 'actions/wishlistActions';
import get from 'lodash/get';
import { INIT, SUCCESS, ERROR, LOADING } from 'utils/asyncStatusHelper';

const defaultState = {
	asyncStatus: INIT,
	data: {},
	products: []
};

export default (state = defaultState, action = {}) => {
	switch (action.type) {
		case GET_WISHLIST_ITEM_REQUEST:
			return Object.assign({}, state, {
				asyncStatus: LOADING
			});
		case GET_WISHLIST_ITEM_SUCCESS:
			return Object.assign({}, state, {
				asyncStatus: SUCCESS,
				products: state.products.concat(action.products.map(item => item.productId)),
				data: Object.assign({}, state.data, action.data)
			});
		case REMOVE_WISHLIST_ITEM_SUCCESS:
			const removedId = get(action.data, ['RemovedItems', 0]);
			return Object.assign({}, state, {
				asyncStatus: SUCCESS,
				products: state.products.filter(item => item !== removedId)
			});
		case GET_WISHLIST_ITEM_ERROR:
			return Object.assign({}, state, {
				asyncStatus: ERROR,
				error: action.error
			});
		case RESET_WISHLIST_ITEM_DATA:
			return defaultState;
		default:
			return state;
	}
};
